<div
  class="banner banner-{{ config.type }}"
  role="alert"
  [attr.aria-live]="config.type === 'error' ? 'assertive' : 'polite'"
  [@slideInFromRight]
>
  <!-- Icon -->
  @if (config.icon) {
    <div class="banner-icon-wrapper">
      <i [class]="config.icon" class="banner-icon"></i>
    </div>
  }

  <!-- Content -->
  <div class="banner-content">
    <h4 class="banner-title">{{ config.title }}</h4>
    <p class="banner-message">{{ config.message }}</p>
  </div>

  <!-- Close Button -->
  @if (config.dismissible) {
    <button
      type="button"
      class="banner-close"
      (click)="handleClose()"
      aria-label="Fermer la notification"
    >
      <i class="pi pi-times"></i>
    </button>
  }
</div>
